// extracted by mini-css-extract-plugin
module.exports = {"colorPicker":"ColorPicker_colorPicker__tAaGE","active":"ColorPicker_active__1Tujn"};